import { useUserInfoQuery } from "Auth/Api/Queries/useUserInfoQuery";
import { AccessRoleCode } from "Infrastructure/Api/Api";

export function useCurrentUser() {
  const { data: user, isLoading } = useUserInfoQuery();

  const hasRole = (role: AccessRoleCode) =>
    user?.userAccessRoles.includes(role) ?? false;

  const isPartner = hasRole(AccessRoleCode.Partner);
  const isRootPartner =
    isPartner && !!user?.partnerID && !user?.partnerParentID;

  return {
    user: user ?? null,
    isLoading,
    isAuthenticated: !!user,
    roles: user?.userAccessRoles ?? [],
    hasRole,
    isSysAdmin: hasRole(AccessRoleCode.SysAdmin),
    isRootPartner,
  };
}

export function useHasRole(role: AccessRoleCode): boolean {
  return useCurrentUser().hasRole(role);
}
